import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/context/LangContext";
import { AuthLayout } from "@/pages/Login";

export default function Register() {
  const { register, loading } = useAuth();
  const { t } = useLang();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "", phone: "" });

  const submit = async (e) => {
    e.preventDefault();
    try {
      await register(form);
      toast.success("Guardian created. You are now protected.");
      nav("/app");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Registration failed");
    }
  };

  return (
    <AuthLayout>
      <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} className="w-full">
        <h1 className="font-display font-black text-4xl tracking-tighter mb-2">{t("register_title")}</h1>
        <p className="text-muted-foreground mb-8">{t("register_sub")}</p>
        <form onSubmit={submit} className="space-y-4" data-testid="register-form">
          <div>
            <Label htmlFor="name">{t("register_name")}</Label>
            <Input data-testid="register-name" id="name" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="Jane Doe" />
          </div>
          <div>
            <Label htmlFor="email">{t("login_email")}</Label>
            <Input data-testid="register-email" id="email" type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
          </div>
          <div>
            <Label htmlFor="phone">{t("register_phone")}</Label>
            <Input data-testid="register-phone" id="phone" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} placeholder="+91 98xxxxxxxx" />
          </div>
          <div>
            <Label htmlFor="password">{t("login_password")}</Label>
            <Input data-testid="register-password" id="password" type="password" required minLength={6} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} placeholder="At least 6 characters" />
          </div>
          <Button data-testid="register-submit" type="submit" disabled={loading} className="w-full h-11 bg-[hsl(var(--primary))] hover:bg-[hsl(var(--primary))]/90 text-white rounded-full">
            {loading ? "..." : t("register_submit")} <ArrowRight className="w-4 h-4 ml-2" />
          </Button>
        </form>
        <div className="text-sm text-muted-foreground mt-6">
          {t("register_switch")}{" "}
          <Link to="/login" className="text-[hsl(var(--primary))] font-medium hover:underline" data-testid="switch-to-login">
            {t("register_switch_link")}
          </Link>
        </div>
      </motion.div>
    </AuthLayout>
  );
}
